// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1E868","name":"styles_name__18NrI","phone":"styles_phone__2nvs_"};